import React, { Fragment } from "react";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { AllCheckItems, certifiedBySchema, GetTableRowData, getTableSubSectionHeader, ImageSection } from "./SchemaAndTemplate";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { SchemaFor92And184DaysChecklist } from "../Periodic/92And184Days/92And184DaysSchema";

function LocomotiveCheckOffList(props) {
  const { reportData } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let removeDuplicates = ReportGroupingUtils.RemoveDuplicateTestCodesFromGroupedReport(reportsByDateAndUser, [
    "LocomotivePeriodicInspectionCheckOffList",
  ]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(removeDuplicates);
  return (
    <React.Fragment>
      {decodedReports.map((report, i) => {
        return (
          <div key={i} className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
            <ReportView key={i} data={report} {...props} />
          </div>
        );
      })}
    </React.Fragment>
  );
}

export default LocomotiveCheckOffList;

const ReportView = (props) => {
  const { data, title } = props;
  const { decodedData, fraHeaderInfo } = data;
  return decodedData.map((singleReport, index) => (
    <div key={index}>
      <ReportTitleSection title={title} fontSizeOverride={"35px"} />
      <ReportFraInfoSectionContainer {...props} />
      <span className="spacer"></span>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.labOilSample.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.replaceAllFilters.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.brushFusesDiodes.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.safetyAppliances.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.brakeShoes.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.truckUndercarriage.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.draftGear.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.handBrake.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.inspectAllBaseBolts.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.batteriesAndChargingSystem.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.electricalGrounds.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.lightingAndIllumination.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.locksAndSecurement.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.HouseKeeping.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.pcSystem.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.electricalCabinets.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.protectiveAndShutdown.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.cabAndLocomotiveSafetyEquipments.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.controlStandThrottle.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.labOilSample.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.muReceptaclesJumperCables.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.transitionCircuit.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.speedIndicator.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.engineCoolingSystem.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.primeMoversDieselEngineInspection.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.accessoryDriveADA.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.checkFluidLevel.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.sandOperationApplication.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.eventRecorder.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.softwareUpdates.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.washCleanLocomotive.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.airBrakeSystemTests.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        <ReportTableSectionRenderer section={SchemaFor92And184DaysChecklist.wheelGeometryAndMiscClearance[0]} rowsData={{}} key={index} />
        <ReportTableSectionRenderer
          section={SchemaFor92And184DaysChecklist.wheelGeometryAndMiscClearance[1]}
          rowsData={singleReport.summary.tab1 || []}
          key={index}
        />
        <ReportTableSectionRenderer
          section={SchemaFor92And184DaysChecklist.wheelGeometryAndMiscClearance[2]}
          rowsData={singleReport.summary.tab2 || []}
          key={index}
        />
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.coupleHeight.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.pilotHeight.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.sideBearingClearance.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.updateDocumentation.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
    </div>
  ));
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/LocomotiveCheckOffList/LocomotiveCheckOffList.jsx